import { Link, Outlet } from '@remix-run/react'

export default function Layout() {
	return (
		<div>
			<header className="container py-6">
				<nav className="flex flex-wrap items-center justify-between gap-4 sm:flex-nowrap md:gap-8">
					<Logo />
					{/*<div className="ml-auto hidden max-w-sm flex-1 sm:block">*/}
					{/*	{searchBar}*/}
					{/*</div>*/}
					{/*<div className="flex items-center gap-10">*/}
					{/*	{user ? (*/}
					{/*		<UserDropdown />*/}
					{/*	) : (*/}
					{/*		<Button asChild variant="default" size="lg">*/}
					{/*			<Link to="/login">Log In</Link>*/}
					{/*		</Button>*/}
					{/*	)}*/}
					{/*</div>*/}
					{/*<div className="block w-full sm:hidden">{searchBar}</div>*/}
				</nav>
			</header>
			<Outlet />
		</div>
	)
}

function Logo() {
	return (
		<Link to="/" className="flex items-center gap-3 text-xl font-medium">
			<img className="h-8 w-8" src="/favicons/android-chrome-512x512.png" />
			Breeze
		</Link>
	)
}
